import type { Mission } from '../missions.ts'

export const nara: Mission = {
  id: "nara",
  name: "National Archives and Records Administration",
  short: "NARA",
  call: "Archives",
  kind: "independent",
  url: "https://www.archives.gov/",
  established: 1934,
  palette: {
    primary: "#2d4d76",
    secondary: "#29393b",
    accent: "#cd5728",
  },
  colorSource: {
    kind: "site",
    url: "https://www.archives.gov/sites/all/themes/nara/css/styles.css",
  },
  motif: "scroll",
  mission: {
    text: "We preserve, protect, and share the historical records of the United States to promote public inquiry and strengthen democratic participation.",
    url: "https://www.archives.gov/files/about/plans-reports/strategic-plan/strategic-plan-framework-2026-2030.pdf",
  },
  fact: {
    text: "Only 1 to 3 percent of the records the federal government creates are important enough to be kept by the National Archives forever.",
    url: "https://www.archives.gov/about",
  },
  seal: {
    file: "public/seals/nara.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-NARA-Seal.svg",
  },
  identifier: {
    about: "https://www.archives.gov/about",
    accessibility: "https://www.archives.gov/global-pages/accessibility",
    foia: "https://www.archives.gov/foia",
    noFear: "https://www.archives.gov/eeo/policy/complaint-activity.html",
    oig: "https://www.archives.gov/oig",
    performance: "https://www.archives.gov/about/plans-reports",
    privacy: "https://www.archives.gov/global-pages/privacy.html",
  },
  media: {
    photos: [
      {
        file: "/media/nara-archives-building.jpg",
        small: "/media/nara-archives-building-sm.jpg",
        alt: "Black-and-white view of the National Archives Building's colonnade and attic story rising above the trees, nearly finished.",
        title: "National Archives Building nearing completion, Washington, D.C., August 1934",
        creator: "National Archives (Records of the National Archives and Records Administration, Record Group 64)",
        source: "https://commons.wikimedia.org/wiki/File:Photograph_of_the_Almost_Complete_Construction_of_the_Exterior_of_the_National_Archives_Building,_Washington,_D.C._(35967824903).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/nara-rotunda.jpg",
        small: "/media/nara-rotunda-sm.jpg",
        alt: "Black-and-white view of the Rotunda for the Charters of Freedom, with its murals, marble floor, and central shrine.",
        title: "Rotunda, National Archives Building, 1986 (Charters of Freedom Photographic Collection)",
        creator: "National Institute of Standards and Technology",
        source: "https://commons.wikimedia.org/wiki/File:ChartersOfFreedom_003.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
